import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../context';
import { ReportTypes } from './components';
import { SecondaryButton } from '../../components';
import {
  STEP_CONTACT_PARTNER,
  STEP_IDENTIFY_CUSTOMER,
  STEP_SELECT_FNOL_CATEGORY,
} from '../../CONSTANTS';
import ButtonWrapper from '../../components/ButtonWrapper';
import styled from 'styled-components';

const SelectFnolTemplateView = () => {
  const {
    fnolCategories,
    selectedFnolTemplate,
    setFnolIntroMarkdown,
    setSelectedFnolCategory,
    setSelectedFnolTemplate,
    setStep,
  } = useFnol();

  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  useEffect(() => {
    if (selectedFnolTemplate) {
      if (selectedFnolTemplate.numberOfBaseQuestions === 0) {
        setFnolIntroMarkdown(selectedFnolTemplate.introductionMarkdown);
        setStep(STEP_CONTACT_PARTNER);
      } else {
        setStep(STEP_IDENTIFY_CUSTOMER);
      }
    }
  }, [selectedFnolTemplate]);

  const handleSelectClick = (template) => {
    setSelectedFnolTemplate(template);
  };

  const handleGoBackClick = () => {
    setSelectedFnolCategory(null);
    setStep(STEP_SELECT_FNOL_CATEGORY);
  };

  return (
    <Wrapper>
      <h3>{t('selectFnolTemplate.header')}</h3>
      <ReportTypes onClick={handleSelectClick} />
      {fnolCategories.length > 1 && (
        <ButtonWrapper>
          <SecondaryButton onClick={handleGoBackClick}>
            {t('buttons.back')}
          </SecondaryButton>
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

export default SelectFnolTemplateView;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
